import React, { useState } from "react";
import FormHeader from "./components/FormHeader";
import Background from "./components/Background";
import * as Yup from "yup";
import FormikForm from "../../components/FormikForm";
import Stack from "@mui/material/Stack";
import InputTextField from "../../components/InputTextField";
import FormikSubmitButton from "../../components/FormikSubmitButton";
import { useTheme } from "@mui/material/styles";
import api from "../../api/apiClient";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Snackbar, Alert } from "@mui/material";

const initialValues = {
  email: "",
  password: "",
};

const validationSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email")
    .required("Email is a required field"),
  password: Yup.string()
    .min(6, "Too short")
    .required("Password is a required field"),
});

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const payload = {
        EmailID: values.email,
        Password: values.password,
      };

      const response = await api.post("/login", payload);

      const { token, permissions } = response.data;

      if (token) {
        // ✅ Pass token + permissions into AuthContext
        login(token, permissions);

        setToast({
          open: true,
          message: "Login successful!",
          severity: "success",
        });

        resetForm();

        // Optional: navigate after short delay so user sees the toast
        setTimeout(() => navigate("/", { replace: true }), 800);
      } else {
        setToast({
          open: true,
          message: "Invalid credentials",
          severity: "error",
        });
      }
    } catch (error) {
      console.error("Login failed:", error.response?.data || error.message);
      setToast({
        open: true,
        message:
          error.response?.data?.message || "Login failed, please try again!",
        severity: "error",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Background>
      <div className="flex items-center justify-center min-h-screen px-4">
        <div className="space-y-5 w-full max-w-md">
          <FormHeader />
          <div className="border py-4 px-6 rounded-xl bg-white shadow-md">
            <div className="text-[20px] border-b-2 pb-3 font-inter font-semibold">
              Welcome Back
            </div>
            <FormikForm
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              <Stack spacing={2.5} className="mt-4">
                <InputTextField
                  label="Email"
                  requiredMark
                  name="email"
                  placeholder="Enter your email"
                />
                <InputTextField
                  label="Password"
                  requiredMark
                  name="password"
                  placeholder="Enter your password"
                  type="password"
                  hiddenPassword
                />
                <FormikSubmitButton
                  name="Login"
                  className="text-center border py-3 cursor-pointer text-white rounded"
                />
              </Stack>
            </FormikForm>
          </div>
        </div>
      </div>

      {/* Toast Notification */}
      <Snackbar
        open={toast.open}
        autoHideDuration={4000}
        onClose={() => setToast({ ...toast, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setToast({ ...toast, open: false })}
          severity={toast.severity}
          sx={{ width: "100%" }}
        >
          {toast.message}
        </Alert>
      </Snackbar>
    </Background>
  );
}
